// src/gatsby-theme-docz/components/Logo/index.js
import React from 'react'
import logo from './ih_logo.svg'

export const Logo = () => <img style={{ 'padding-top': '30px', 'max-width': '300px' }} src={logo} alt="Inbox Health Support Documentation" />
